import request from '@/utils/request'

// 获取列表
export const getNews = (params) => request({url: '/news', method: 'get', params:params });
// 根据id获取详情
export const getNewsDetails = (params) => request({url: `newsDetails/${params.pid}`, method: 'get' });